import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { Stars } from "@/components/Feedback";
import { api } from "@/lib/api";

export const TestimonialWall = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/testimonials").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="testimonial-wall">
      <p className="text-xs uppercase tracking-[0.2em] text-amber-400 font-semibold mb-2">Client stories</p>
      <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-10 max-w-xl">What our clients say</h2>
      <div className="columns-1 md:columns-2 lg:columns-3 gap-6 [&>*]:mb-6">
        {items.map((t, i) => (
          <figure key={t.id} data-testid={`testimonial-${t.id}`} style={{ animationDelay: `${i * 80}ms` }}
            className="fade-up break-inside-avoid rounded-xl border border-slate-800 bg-slate-900/70 p-6 hover:border-amber-400/40 transition-colors">
            <Quote className="h-6 w-6 text-amber-400/70 mb-3" />
            <blockquote className="text-slate-200 leading-relaxed mb-5">“{t.quote}”</blockquote>
            <figcaption className="flex items-center justify-between gap-3">
              <span className="text-sm text-slate-400">{t.credit}</span>
              <Stars value={5} size="h-3.5 w-3.5" />
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};
